module.exports = __webpack_public_path__ + "static/img/mask.864a7af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/mask.png
// module id = tY7x
// module chunks = 1